import { render, staticRenderFns } from "./CreateOtherQRCode.vue?vue&type=template&id=488a0e4e&scoped=true&"
import script from "./CreateOtherQRCode.vue?vue&type=script&lang=js&"
export * from "./CreateOtherQRCode.vue?vue&type=script&lang=js&"
import style0 from "./CreateOtherQRCode.vue?vue&type=style&index=0&id=488a0e4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488a0e4e",
  null
  
)

export default component.exports